<router-outlet></router-outlet>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast></p-toast>
<app-loader></app-loader>
<div *ngIf="workerScheduleBlocked" class="worker-schedule-overlay" role="alertdialog" aria-modal="true">
    <div class="worker-schedule-card">
        <i class="pi pi-clock worker-schedule-icon"></i>
        <h2>Estás fuera de horario</h2>
        <p>{{workerScheduleMessage}}</p>
        <button pButton type="button" label="Cerrar sesión" icon="pi pi-sign-out"
                (click)="logoutForSchedule()"></button>
    </div>
</div>
